import React, { useState, useEffect } from "react";
import Input from "../../../../../../../components/Input/Input";
import Select from "../../../../../../../components/Select/Select";
import Button from "../../../../../../../components/Button/Button";
import PermitsSelector from "./PermitsSelector/PermitsSelector";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import "./MemberData.css";
//service
import { groupService } from "../../../../../../../services/Group";
//handle
import HandleResponse from "../../../../../../../utils/HandleResponse";

const MemberData = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const { member, isEditing } = location.state || {};
  const [permissions, setPermissions] = useState([
    { title: "Select all", label: "selected-all", value: false },
    //{title: 'Manage settings', label: 'can_manage_settings', value: false},
    { title: "Add members", label: "can_add_members", value: false },
    { title: "Delete members", label: "can_delete_members", value: false },
    { title: "Approve Requests", label: "can_approve_requests", value: false },
    { title: "Send messages", label: "can_send_messages", value: false },
    {
      title: "Verify and accept requests",
      label: "can_verify_requests",
      value: false,
    },
    { title: "Delete group", label: "can_delete_group", value: false },
    {
      title: "Assign permissions to members",
      label: "can_assign_permissions",
      value: false,
    },
  ]);

  // Filtrar permisos activos para pasar al selector
  const activePermissions = permissions
    .filter((p) => p.value)
    .map((p) => p.permission);
  const [formData, setFormData] = useState({
    name: member?.name || "",
    role: member?.role || "",
    permits: member?.permits || [],
    status: member?.status || "Active",
    dateAdded: member?.dateAdded || "",
    applicationDate: member?.applicationDate || "",
  });

  useEffect(() => {
    fetchPermissions();
  }, [id]);

  const fetchPermissions = async () => {
    try {
      const response = await groupService.getPermissionsmemeberGroup(
        id,
        member.user_id,
      );
      if (response.status === "success" && response.data) {
        let count = 0;
        let data = permissions.map((permission) => {
          const value = response.data[permission.label];
          if (value !== undefined && value) {
            count++;
          }
          permission.value = value === undefined ? false : value;
          return permission;
        });
        data[0].value = count === 8 ? true : false;
        setPermissions(data);
      }
    } catch (error) {
      console.error("Error fetching permissions:", error);
    }
  };

  const handleEdit = () => {
    handleUpdatePersmissions();
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleUpdatePersmissions = async () => {
    try {
      const data = {
        can_manage_settings: permissions.find(
          (p) => p.label === "can_manage_settings",
        ).value,
        can_add_members: permissions.find((p) => p.label === "can_add_members")
          .value,
        can_delete_members: permissions.find(
          (p) => p.label === "can_delete_members",
        ).value,
        can_approve_requests: permissions.find(
          (p) => p.label === "can_approve_requests",
        ).value,
        can_send_messages: permissions.find(
          (p) => p.label === "can_send_messages",
        ).value,
        can_verify_requests: permissions.find(
          (p) => p.label === "can_verify_requests",
        ).value,
        can_delete_group: permissions.find(
          (p) => p.label === "can_delete_group",
        ).value,
        can_assign_permissions: permissions.find(
          (p) => p.label === "can_assign_permissions",
        ).value,
      };
      const response = await groupService.updatePermissionsmemeberGroup(
        id,
        member.user_id,
        data,
      );
      if (response.status === "success") {
        HandleResponse.showSuccessModal({
          title: { text: "Success", highlight: "updating" },
          message: "Permissions updated successfully",
          confirmText: "Accept",
          onConfirm: () => {
            HandleResponse.hideModal();
            navigate(-1);
          },
        });
      } else {
        HandleResponse.showErrorModal({
          title: { text: "Error", highlight: "updating" },
          message: "Error updating permissions",
          confirmText: "Understood",
          onConfirm: () => {
            HandleResponse.hideModal();
          },
        });
      }
    } catch (error) {
      console.error("Error updating permissions:", error);
      HandleResponse.showErrorModal({
        title: { text: "Error", highlight: "updating" },
        message: "Error updating permissions",
        confirmText: "Understood",
        onConfirm: () => {
          HandleResponse.hideModal();
        },
      });
    }
  };

  return (
    <div className="member-data-container">
      <h2 className="member-title">
        {isEditing ? "Edit" : "View"}
        <span className="title-highlight"> members</span>
      </h2>

      <div className="member-form">
        <div className="form-row">
          <div className="form-field">
            <h3>Name of member</h3>
            <Input
              type="text"
              value={formData.name}
              onChange={(e) => handleInputChange("name", e.target.value)}
              disabled={true}
            />
          </div>
          <div className="form-field">
            <h3>Role</h3>
            <Select
              options={[
                { value: "owner", label: "Owner" },
                { value: "admin", label: "Admin" },
                { value: "user", label: "User" },
              ]}
              value={formData.role}
              onChange={(e) => handleInputChange("role", e.target.value)}
              isDisabled={!isEditing}
              isClearable={false}
            />
          </div>
          <div className="form-field">
            <h3>Permits</h3>
            <PermitsSelector
              permissions={permissions}
              setPermissions={setPermissions}
              disabled={!isEditing}
            />
          </div>
        </div>

        <div className="form-row">
          {/*<div className="form-field">
            <h3>Status</h3>
            <Select
              options={[
                { value: "Active", label: "Active" },
                { value: "Inactive", label: "Inactive" },
                { value: "Pending", label: "Pending" },
                { value: "Blocked", label: "Blocked" },
              ]}
              value={formData.status}
              onChange={(e) => handleInputChange("status", e.target.value)}
              isDisabled={!isEditing}
              isClearable={false}
            />
          </div>*/}
          <div className="form-field">
            <h3>Date added</h3>
            <Input type="text" value={formData.dateAdded} disabled={true} />
          </div>
          <div className="form-field">
            <h3>Date of application entry</h3>
            <Input
              type="text"
              value={formData.applicationDate}
              disabled={true}
            />
          </div>
        </div>
      </div>

      {isEditing && (
        <div className="edit-button-container">
          <Button
            variant="warning"
            onClick={() => navigate(-1)}
            className="edit-button"
            fullWidth
          >
            Cancel
          </Button>
          <Button onClick={handleEdit} className="edit-button" fullWidth>
            Save
          </Button>
        </div>
      )}
    </div>
  );
};

export default MemberData;
